import { Form, Input, Image, Button } from "antd";
import { Rules } from "../../core/Rules";
import {
  getDateString,
  getFullPath,
  isImageMedia,
} from "../../core/helper/UtilHelper";
import Upload from "../../core/component/Upload";

export const getCompanyFilesCPColumns = () => {
  const downloadFile = async (path: string, fileName: string) => {
    const response = await fetch(path);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  };

  return [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Dosya / Önizleme",
      dataIndex: "view",
      key: "view",
      render: (_: any, row: any) => {
        const isImage = isImageMedia(row.extension);
        const path = getFullPath(row.uid);
        return isImage ? (
          <Image width={50} height={50} src={path} />
        ) : (
          <Button
            type="link"
            onClick={() => downloadFile(path, `${row.name}.${row.extension}`)}
          >
            Görüntüle
          </Button>
        );
      },
    },
    {
      title: "Dosya Adı",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Yüklenme Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value: any) => getDateString(value),
    },
    {
      title: "Yükleyen",
      dataIndex: "createdWorker",
      key: "createdWorker",
      render: (value: any) =>
        value ? value?.name + " " + value?.surname : "-",
    },
  ];
};

export const getCompanyFilesCPFormItems = (companyId: string) => {
  return (
    <>
      <Form.Item
        name="name"
        label="Dosya Adı"
        rules={[Rules.required, Rules.max(255)]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="media" label="Dosya" rules={[Rules.required]}>
        <Upload />
      </Form.Item>
      <Form.Item
        hidden
        name="company"
        initialValue={"api/companies/" + companyId}
      >
        <Input />
      </Form.Item>
    </>
  );
};
